
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wins",
      function () {
        return require("private-next-pages/wins.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wins"])
      });
    }
  